import defaultLocales from 'globals/locales/default';
import { MobileOriginSingleRowDataProps } from 'ui-elements/forms/FsMobileOriginForm/MobileOriginSingleRow/MobileOriginSingleRow';

interface GetMobileOriginSingleRowProps {
  androidScheme?: string;
  androidPackage?: string;
  iOsBundleIdentifier?: string;
}

export const getMobileOriginRows = ({
  androidScheme,
  androidPackage,
  iOsBundleIdentifier,
}: GetMobileOriginSingleRowProps): MobileOriginSingleRowDataProps[] => [
  {
    name: 'androidScheme',
    caption: defaultLocales.androidScheme,
    redirect: androidScheme || '',
  },
  {
    name: 'androidPackage',
    caption: defaultLocales.androidPackage,
    redirect: androidPackage || '',
  },
  {
    name: 'iOsBundleIdentifier',
    caption: defaultLocales.iOsBundleIdentifier,
    redirect: iOsBundleIdentifier || '',
  },
];
